/* eslint-disable import/prefer-default-export */
import axiosInstance from 'services/common/instance';

export const apiEmailRegister = async (params: { email: string })
  : Promise<unknown> => {
  const res = await axiosInstance.post('api/v2/clients/email-registers', params);
  return res;
};
